export default __webpack_public_path__ + "static/media/singleProductBcg.7eb87f33.jpeg";